import { render, staticRenderFns } from "./AppFeatures.vue?vue&type=template&id=4f25d57f&"
import script from "./AppFeatures.vue?vue&type=script&lang=js&"
export * from "./AppFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports